import {callApi} from "./Api";

export const REGISTER = 'REGISTER';

export const register = (code, obj, status) => (dispatch, getState) => {
  let url;
  if (status === 'clientRegister') {
    url = `invitations/with/${code}/client-register`;
  }

  if (status === 'businessUnitMemberRegister') {
    url = `invitations/with/${code}/business-unit-team-member-register`;
  }

  callApi(dispatch, getState, REGISTER, url, {
    method: 'POST',
    body: JSON.stringify(obj)
  });
}


// WEBPACK FOOTER //
// ./src/actions/CreateClientAccount.js